import React, { FunctionComponent } from 'react';

import { MotorFullPageProps } from 'scenes/motor/types';
import {
  getPayableClaims,
  getClaimsMade,
  getDriverType,
} from 'scenes/motor/selectors';
import { SingleSegmentedControlStep } from 'scenes/common/components/Steps';
import { NONE_TO_FIVE_PLUS_OPTIONS } from 'scenes/common/types';

const STATE_KEY = 'payableClaims';

const PayableClaimsStep: FunctionComponent<MotorFullPageProps> = ({
  flowType,
  funnelState,
  onNext,
}) => {
  const options = NONE_TO_FIVE_PLUS_OPTIONS.filter(
    (option) => option.value <= getClaimsMade(funnelState)
  );

  const driverType = getDriverType(flowType);

  return (
    <SingleSegmentedControlStep
      onNext={onNext}
      question={`For how many of these claims did the ${driverType} driver have to pay an excess?`}
      stateKey={STATE_KEY}
      options={options}
      defaultStateValue={getPayableClaims(funnelState)}
      validationRules={{
        validate: {
          oneOf: (value) => options.some((option) => option.value === value),
        },
      }}
    />
  );
};

export default PayableClaimsStep;
